/* eslint react/display-name: "off" */
/* eslint react/prop-types: "off" */
import React from "react";

import { EditButton, RemoveButton } from "srx-shared/mui";

import { ChangeStatusButton } from "./ChangeStatusButton";
import { DistributorItem } from "./DistributorItem";

export const Actions = ({ row }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      width: "100%",
      margin: "3px 0"
    }}
  >
    <div style={{ display: "flex", marginRight: "10px" }}>
      <EditButton row={row} item={DistributorItem} tip="distributor" />
    </div>
    <ChangeStatusButton row={row} />
    <RemoveButton
      row={row}
      item={DistributorItem}
      tip="distributor"
      modalProps={{ size: "sm" }}
    >
      Are you sure you want to delete distributor:
      <br />
      <pre>
        <b>{row.name}</b>
      </pre>
    </RemoveButton>
  </div>
);
